export interface IWarehouseLine {
  id: number
  name: string
  bank: string
  glAccountNo: string
  commitment: number
  advanceRate: number
  outstanding?: number
  available?: number
  utilization?: number
  loanCount?: number
  glBalance?: number
  variance?: number
}

export interface ILoanSubledgerRow {
  id: number
  loanId: string
  borrower: string
  product: string
  noteRate: number
  fundedAmount: number
  invAccountNo: string
  status: string
  warehouseLine: string
  advanceRate?: number
  whOutstanding?: number
  inventoryBook?: number
  salePrice: number
  investor: string
  realizedGain?: number
  escrowBalance: number
  fundedDate: string | null
  servicing: string
  msrValue: number
}

export const LOAN_SUBLEDGER_STATUSES = [
  'Held',
  'Held-Construction',
  'Sold-Pending',
  'Repurchased',
  'Sold-Settled',
  'Locked',
]

export const LOAN_SERVICING_OPTIONS = ['Released', 'Retained']

export const emptyWarehouseLine = (): Partial<IWarehouseLine> => ({
  name: '',
  bank: '',
  glAccountNo: '',
  commitment: 0,
  advanceRate: 0,
})

export const emptyLoanSubledgerRow = (): Partial<ILoanSubledgerRow> => ({
  loanId: '',
  borrower: '',
  product: '',
  noteRate: 0,
  fundedAmount: 0,
  invAccountNo: '',
  status: 'Held',
  warehouseLine: '',
  salePrice: 0,
  investor: '',
  escrowBalance: 0,
  fundedDate: '',
  servicing: 'Released',
  msrValue: 0,
})
